import React from "react";

const InventoryFilters = ({ filters, onFilterChange, onApply, onReset, categories, eventData }) => {
  const {
    dateFilter,
    fromDate,
    toDate,
    category,
    SelectedType,
    productCode,
    title,
    promotionFilter,
    showWebFilter,
  } = filters;

  const handleButtonClickType = (type) => onFilterChange("SelectedType", type);
  const handleButtonClickPromotion = (value) => onFilterChange("promotionFilter", value);
  const handleButtonClickShowWeb = (value) => onFilterChange("showWebFilter", value);

  return (
    <div className=" min-w-[320px] border-r border-gray-200 bg-white h-[calc(100vh-80px)] overflow-y-auto p-6 space-y-6 shadow-inner">
  <div className="flex items-center justify-between mb-2">
    <h2 className="text-sm font-bold text-gray-400 uppercase tracking-widest">Filter Options</h2>
    <button onClick={onReset} className="text-xs text-blue-600 hover:underline">Reset All</button>
  </div>

  {/* Date Section */}
  <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
    <label className="text-sm font-semibold text-gray-700 block mb-2">Timeline</label>
    <select
      value={dateFilter}
      onChange={(e) => onFilterChange("dateFilter", e.target.value)}
      className="w-full border-gray-300 rounded-lg p-2.5 text-sm focus:ring-blue-500 focus:border-blue-500 bg-white"
    >
      <option value="">Choose range...</option>
      <option value="today">Today</option>
      <option value="previous30days">Past 30 Days</option>
      <option value="next30days">Next 30 Days</option>
      {/* ... Add other options here */}
    </select>
    
    <div className="grid grid-cols-2 gap-2 mt-3">
      <input
        type="date"
        value={fromDate}
        onChange={(e) => onFilterChange("fromDate", e.target.value)}
        className="w-full border-gray-300 rounded-lg p-2 text-xs"
      />
      <input
        type="date"
        value={toDate}
        min={fromDate}
        onChange={(e) => onFilterChange("toDate", e.target.value)}
        className="w-full border-gray-300 rounded-lg p-2 text-xs"
      />
    </div>
  </div>

  {/* Identity Section */}
  <div className="space-y-4">
    <div>
      <label className="text-sm font-semibold text-gray-700">Category</label>
      <select
        value={category}
        onChange={(e) => onFilterChange("category", e.target.value)}
        className="w-full mt-1 border-gray-300 rounded-lg p-2.5 text-sm"
      >
        <option value="">All Categories</option>
        {categories.map((cat) => (
          <option key={cat._id} value={cat._id}>{cat.title}</option>
        ))}
      </select>
    </div>

    <div>
      <label className="text-sm font-semibold text-gray-700">Quick Search</label>
      <input
        type="text"
        value={productCode}
        onChange={(e) => onFilterChange("productCode", e.target.value)}
        placeholder="Product Code..."
        className="w-full mt-1 border-gray-300 rounded-lg p-2.5 text-sm mb-2"
      />
      <input
        type="text"
        value={title}
        onChange={(e) => onFilterChange("title", e.target.value)}
        placeholder="Item Title..."
        className="w-full border-gray-300 rounded-lg p-2.5 text-sm"
      />
    </div>
  </div>

  {/* Toggle Buttons Section */}
  <div className="space-y-3">
    <div className="flex p-1 bg-gray-100 rounded-lg">
      <button
        onClick={() => handleButtonClickType("package")}
        className={`flex-1 py-1.5 text-xs font-medium rounded-md transition-all ${SelectedType === "package" ? "bg-white shadow text-blue-600" : "text-gray-500 hover:text-gray-700"}`}
      >
        Package
      </button>
      <button
        onClick={() => handleButtonClickType("product")}
        className={`flex-1 py-1.5 text-xs font-medium rounded-md transition-all ${SelectedType === "product" ? "bg-white shadow text-blue-600" : "text-gray-500 hover:text-gray-700"}`}
      >
        Product
      </button>
    </div>

    <div className="space-y-2">
        <button
          onClick={() => handleButtonClickPromotion("true")}
          className={`w-full text-left px-3 py-2 text-xs border rounded-lg transition-all ${promotionFilter === "true" ? "border-blue-500 bg-blue-50 text-blue-700 font-bold" : "border-gray-200 text-gray-600 hover:bg-gray-50"}`}
        >
          ✨ On Promotion
        </button>
        <button
          onClick={() => handleButtonClickShowWeb("true")}
          className={`w-full text-left px-3 py-2 text-xs border rounded-lg transition-all ${showWebFilter === "true" ? "border-blue-500 bg-blue-50 text-blue-700 font-bold" : "border-gray-200 text-gray-600 hover:bg-gray-50"}`}
        >
          🌐 Visible on Website
        </button>
    </div>
  </div>

  <button onClick={onApply} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl shadow-lg shadow-blue-100 transition-all transform active:scale-95">
    Apply Filters
  </button>
</div>
  );
};

export default InventoryFilters;
